import { Component, Input, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-truck-report-header',
  templateUrl: './truck-report-header.component.html',
  styleUrls: ['./truck-report-header.component.css']
})
export class TruckReportHeaderComponent {

	constructor(
		private commonService: CommonService,
	){}
	@Input() device: any;
	@Input() data: any;
	@Input() currentSite: any;
	@Input() selectedPeriod: any;
	

	nominalVoltage: number;
	toDayDate: string;
	weeksOfOperation: number = 0;
	selectedPeriodFormatted: string = '';

	ngOnChanges(changes: SimpleChanges) {
		const deviceInfo =  this.device.config_info;
		this.formatPeriod(this.selectedPeriod, deviceInfo);
		this.calculateWeeksOfOperation(deviceInfo, this.selectedPeriod);

		this.toDayDate = moment().format('MM/DD/YYYY');
		this.nominalVoltage = this.device?.config_info?.nominal_voltage ?? 0;

	}

	formatPeriod(period: string, deviceInfo: any) {
		const oldestTimestamp = deviceInfo.installation_date;
		const { from, to } = this.commonService.getDateRange(period, oldestTimestamp, true);
		if(!from || !to) {
			this.selectedPeriodFormatted = '-'
			return
		}
		this.selectedPeriodFormatted = `${moment(from).format('M/D/YYYY')} - ${moment(to).format('M/D/YYYY')}`;
	}

	calculateWeeksOfOperation(deviceInfo: any, period: string) {
		this.weeksOfOperation = this.data?.[period]?.operationWeeks[deviceInfo.mac_address] ?? 0;
	}
}
